// Returns "isMobile" as prop. True if current screen equal or lower than provided size,
// false - if more than provided size

import { PureComponent } from 'react'
import throttle from 'lodash/throttle'

const withResolution =
  (isMobile, dir, withThrottle = true) =>
  (Component) => {
    return class Resolution extends PureComponent {
      state = {
        result: null,
        trackedValue: window.isNaN(isMobile) ? 0 : Number(isMobile),
      }

      handleResize = () => {
        if (dir) {
          this.setState((state) => ({
            ...state,
            result: window.innerWidth >= this.state.trackedValue,
          }))
        } else {
          this.setState((state) => ({
            ...state,
            result: window.innerWidth <= this.state.trackedValue,
          }))
        }
      }

      throttledHandleResize = withThrottle ? throttle(this.handleResize, 400) : this.handleResize

      componentDidMount() {
        this.handleResize()
        window.addEventListener('resize', this.throttledHandleResize)
      }

      componentWillUnmount() {
        this.throttledHandleResize?.cancel?.()
        window.removeEventListener('resize', this.throttledHandleResize)
      }

      render() {
        return this.state.result !== null ? <Component isMobile={this.state.result} {...this.props} /> : null
      }
    }
  }

export default withResolution
